import { webLightTheme } from '@fluentui/react-components';
import { AiHubPageUnstyled } from '@office-start/ai-hub-page-component';
import { logModuleLoadDuration } from '@office-start/ai-hub-telemetry-service';
import { DevuiToolContextProvider } from '@office-start/devui-contexts';
import { useFeatureGates } from '@office-start/feature-gates-service';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import { useLogPageView, withLazyErrorBoundary, } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var LazyDevUIToolComponent = lazy(function () {
    return import(
    /* webpackChunkName: "devui-tool-component" */ '@office-start/devui-tool-component');
});
// Existing lazy boundaries for Browse components
var aiHubComponentName = 'BrowseBaseComponentAIHubModule';
var BrowseBaseComponentLazyBoundary = withLazyErrorBoundary(lazy(function () {
    var loadPromise = import(
    /* webpackChunkName: "browse-base-component" */ '@office-start/browse-base-component');
    return logModuleLoadDuration(loadPromise, aiHubComponentName);
}), aiHubComponentName);
var BrowseAIHubComponentLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "browse-v2-component" */ '@office-start/browse-ai-hub-component');
}), 'BrowseAIHubComponent');
var BrowseV2ComponentLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "browse-v2-component" */ '@office-start/browse-v2-component');
}), 'BrowseV2Component');
var moduleName = 'Browse';
var componentName = 'BrowseV2';
export var BrowsePage = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var featureGates = useFeatureGates().data;
    var isBrowseV2ExperienceEnabled = (_c = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.browseGates) === null || _b === void 0 ? void 0 : _b.browseV2Enabled) !== null && _c !== void 0 ? _c : true;
    // This is FG for loading the browse npm package from 1JS artifacts
    var isBrowse1JSBundleEnabled = ((_e = (_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _d === void 0 ? void 0 : _d.browseGates) === null || _e === void 0 ? void 0 : _e.browse1JSBundleEnabled) || false;
    var isBrowseDevUIEnabled = ((_g = (_f = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _f === void 0 ? void 0 : _f.browseGates) === null || _g === void 0 ? void 0 : _g.browseDevUIEnabled) || false;
    var url = window.location.pathname; // Get the current URL path
    if (isBrowse1JSBundleEnabled) {
        return React.createElement(BrowseAIHubComponentLazyBoundary, null);
    }
    var componentToRender = (React.createElement(AiHubPageUnstyled, { useLogPageViewHook: useLogPageView, name: moduleName, LazyComponent: isBrowseV2ExperienceEnabled
            ? BrowseV2ComponentLazyBoundary
            : BrowseBaseComponentLazyBoundary, componentName: isBrowseV2ExperienceEnabled ? componentName : 'BrowseBase' }));
    if (isBrowseDevUIEnabled) {
        // render dev ui tool component
        if (url === null || url === void 0 ? void 0 : url.includes('/devuitool/')) {
            componentToRender = (React.createElement(LazyDevUIToolComponent, { onedrivePath: "/aihubbrowse/diagnostics" }));
        }
        // enable dev ui context if dev ui is enabled
        componentToRender = (React.createElement(DevuiToolContextProvider, null, componentToRender));
    }
    return (
    // Enable Fluent UI theme as light mode till dark mode bugs are fixed for the Browse page
    React.createElement(OfficeFluentProvider, { theme: webLightTheme }, componentToRender));
};
//# sourceMappingURL=BrowsePage.js.map